import {useMemo} from 'react';

import GuestApp from 'GuestApp';
import UserApp from 'UserApp';
import {history} from 'context/history';

import ClientApp, {CLIENT_CONNECT_TOKEN_QUERY} from './ClientApp';

const App: React.FC = (props) => {
    const isClientUrl = useMemo(() => {
        const urlParams = new URLSearchParams(history.location.search);
        return history.location.pathname.startsWith('/client') || urlParams.has(CLIENT_CONNECT_TOKEN_QUERY);
    }, []);

    const isGuestUrl = useMemo(() => history.location.pathname.startsWith('/guest'), []);

    return isClientUrl ? <ClientApp {...props} /> : isGuestUrl ? <GuestApp {...props} /> : <UserApp {...props} />;
};

export default App;
